<div class="list-block">
    <mat-list class="list-all">
        <ng-container *ngFor="let item of dataList">
            <mat-list-item>
                <span>
                    {{ item.text.fullLabel }}<app-tooltip *ngIf="item.text.summary" [text]="item.text.summary"></app-tooltip>
                </span>
            </mat-list-item>
            <mat-list-item class="value">
                {{ formatValue(item.value, item.typeCode) }}
            </mat-list-item>
        </ng-container>
    </mat-list>

    <mat-list class="list-items">
        <mat-list-item *ngFor="let item of dataList">
            <span class="label">{{ item.text.fullLabel }}
                <app-tooltip *ngIf="item.text.summary" [text]="item.text.summary"></app-tooltip>
            </span>
            <span class="value">{{ formatValue(item.value, item.typeCode) }}</span>
        </mat-list-item>
    </mat-list>
</div>
